<template>
	<div class="row container-fluid px-0 d-flex justify-content-center">
    	<br>
    	<h1 class="page-title letraDelTitulo col-12">VERIFICACIÓN DE FIRMAS</h1>


    	<div class="col-6 padding-div-low ">
    		<div class="area-claro">	
    			<div class="form-group">
             		<label for="codigoVerificacion">Ingrese el código de verificación QR</label>
             		<input id="codigoVerificacion" v-model="qr" class="form-control form-control-claro" placeholder="Código de Verificación QR" autocomplete="off"/>
        		</div>
              	<div class="text-right">
                	<button class="btn btn-primary overwrapDeBotones btn-buscar" id="buscarFirmas" @click="buscarFirmas()"><i class="fa fa-search"></i>&nbsp;&nbsp;</button>
              	</div>
    		</div>
    	</div>



    	<div v-if="firmas"  class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 padding-div-low">

        	<div class="area-claro">


            <div>

              <div v-if="!firmasfirmanovigente">

                <h4 style="color: black; text-align: center">FIRMA VIGENTE</h4>
                

              </div>


              <div v-else="firmasfirmanovigente">

                <h4 style="color: black; text-align: center">FIRMA NO VIGENTE</h4>
                

              </div>

              
              

            </div>


        		<transition name="fade">



         <!--  <div v-if="(firmas == undefined || firmas == null || firmas.length <= 0)" style="background-color:white; padding: 8px;">

            <div class="d-flex justify-content-center">
              <i class="fas fa-check mr-sm-2" style="font-size: 25px;"></i>
              <div class="align-content-center">
                <h5>Verificación de recibo de firmas a encontrar</h5>
                 Esto es lo que se muestra antes de la busqueda 
              </div>
            </div>
          </div> -->


          <TablaDeResultadosFirmas 
            v-if="firmas != undefined && firmas != null"
            
            v-on:valorParaElPadreAccion="accionRealizar"
            :AccionesMostrar="accionesdelaTablaDeResultadosFirmas"
            :TablaVerificacionReciboDeFirmas="firmas"
            :TablaVerificacionReciboDeFirmasFecha="firmasfecha"
            :TablaVerificacionReciboDeFirmasFechaActual="firmasfechaactual"
            :TablaVerificacionReciboDeFirmasFirmaNoVigente="firmasfirmanovigente"
            v-on:restablecervalores="restablecerValoresDespuesDeGuardarOEliminar"
            :tituloTablaVerificacionReciboDeFirmas="tituloTablaString"
            >

          </TablaDeResultadosFirmas>
          </transition>




        	</div>


        </div>


        




	</div>
</template>
<script>
	import enumeraciones from '@/../static/js/enumeraciones'
  	import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
  	import catalogos from '@/../static/js/catalogos'
  	import api from '@/../static/js/api'
  	import comun from '@/../static/js/comun'
  	import axios from 'axios'
  	import func from '../../../SIVAC/Comun/Funciones/comun.js'
  	import TablaDeResultadosFirmas from '@/components/SIVAC/Comun/TablaDeResultadosFirmas'
    import FiltroVerificacionReciboDeFirmas from '@/components/SIVAC/Comun/FiltroVerificacionReciboDeFirmas'

	export default{
		components: {
      FiltroVerificacionReciboDeFirmas,
      TablaDeResultadosFirmas
      },

		data(){
			return{
				enumeraciones,
        		enumeraciones_sicpo,
        		nombreDeVariableDelComponente: "cargoPaginaOficial",
       	 		qr: "",
       	 		
        		firmas: null,
                firmasfecha:null,
        		firmasfechaactual:null,
        	    firmasfirmanovigente:null,
        		Firma: null,
        	    FechaInicial: null,
        		FechaFinal: null,
        		tituloTablaString: '',
        		tituloSeleccionadodelFiltro: '',


        		accionesdelaTablaDeResultadosFirmas:{
		        alta: true,
		        impresion: true,
		        cambios: true,
		        visualizacion: true,
		        altamanual: true,
		        bajapersona: true,
		        mensaje: true,
		        output: null,
		        reportes: true,
		        consulta: false,
            verificacion: true,
        },




			}




		}, 

		

		mounted() {
      		this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
      	},

      	methods: {


      		buscarFirmas:function() 

      		{
        this.firmasfecha= null; 
        const parametros = 
        {
                               
          EsPrueba: this.enumeraciones.EsPrueba,
          
          Hash: this.qr


        }
        if(this.validarDatosBusqueda(parametros))
        {
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

          axios.post(api.conexion + api.SIVAC.sistema.verificacion.firmas.BuscarVerificaciondeRecibodeFirmas, parametros, headerPeticion)
          .then(respuesta => { 
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              //Cargar Datos de Procesados
              this.firmas = respuesta.data.Firmas;
              this.firmasfechaactual= respuesta.data;
              this.firmasfirmanovigente= respuesta.data.FirmaNoVigente;
              this.$nextTick(()=> { PaginarTabla('tablaVerificacionReciboDeFirmasPaginacion_table', 10)}); 
              // comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.tituloTablaString = "Comprobante de verificación del recibo de una firma";
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }
      },


      /**
         * Función encargada de restablecer los valores de la pantalla
         */
      restablecerValoresDespuesDeGuardarOEliminar()
      {
        
        
        this.limpiarValores();
        // this.limpiarTablaResultados(); // para que se quite la tabla
        // this.buscarProcesadoAPI();

      },

      /** 
       * Metodo encargado de habilitar los componentes de acuerdo a la acción seleccionada (alta, impresion, alta manual, baja procesado)
       * en la tabla de resultados.
       * @param {object} datos [datos: Accion{Alta, Impresión, Alta Manual y Baja Procesado}]
       */
      accionRealizar:function(datos)
      {



      },


       /** 
       * Metodo encargado de limpiar los valores de la tabla de resultados.
       */
      limpiarTablaResultados: function()
      {
        this.firmas = null;
      },


      /** 
       * Metodo encargado de limpiar los valores de Firma.
       */
      limpiarValores: function()
      {
        
        this.Firma = null;
        
      },




      		FechaAPalabras: function(fecha){
          		return func.FechaAPalabras(fecha)
      		},
      		agregarCeros : function(monto){
          		return func.agregarCeros(monto)
      		},
      		numerosAPalabras: function(numero){
          		return func.numerosAPalabras(numero)
      		},
      		validarDatosBusqueda: function(datos){
      			if(datos.Hash == null || datos.Hash == undefined || datos.Hash == ''){
      				comun.mensajeDeAlerta("Favor de ingresar el código de verificación que viene en su recibo", null, null);
          			return false;
      			}
      			return true;
      		}
    	}






	}
</script>
<style scoped>
	.page-title {
    background-color: rgb(0,117,115);
    	color: #FFF;
    	padding: 2vh 20vw;
  	}
    .btn-buscar{
    background-color: var(--gris-pj);
  }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/Funciones/VerificacionDeFirmas/BusquedaVerificacionFirmas.vue